/* NEXLETE — cart.
   Quantity and removal go through /cart/change.js and the page re-reads the
   server's totals. Recomputing prices in the browser risks showing a number
   that differs from what checkout charges. */
(function () {
  const root = document.querySelector("[data-nx-cart]");
  if (!root || !window.fetch) return;

  async function change(key, quantity) {
    root.classList.add("nx-cart__busy");
    try {
      const res = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity }),
      });
      if (!res.ok) throw new Error("cart update failed");
      // Re-render from the server so line totals, subtotal and any cart-level
      // discounts stay authoritative.
      window.location.reload();
    } catch (e) {
      root.classList.remove("nx-cart__busy");
    }
  }

  root.addEventListener("click", (e) => {
    const line = e.target.closest("[data-nx-line]");
    if (!line) return;
    const key = line.dataset.key;
    const input = line.querySelector("[data-nx-qty-input]");

    if (e.target.matches("[data-nx-remove]")) {
      e.preventDefault();
      change(key, 0);
      return;
    }
    const step = e.target.closest("[data-nx-step]");
    if (step && input) {
      e.preventDefault();
      const next = Math.max(0, parseInt(input.value, 10) + parseInt(step.dataset.nxStep, 10));
      change(key, next);
    }
  });

  root.addEventListener("change", (e) => {
    if (!e.target.matches("[data-nx-qty-input]")) return;
    const line = e.target.closest("[data-nx-line]");
    change(line.dataset.key, Math.max(0, parseInt(e.target.value, 10) || 0));
  });
})();

/* Point "keep shopping" at the collection the shopper actually came from.

   The link is rendered server-side with a sensible fallback (the collection
   matching the bag's gender), so this only ever improves it — if there is no
   stored collection, or storage throws, the markup is left exactly as it is. */
(function () {
  const link = document.querySelector("[data-nx-keep]");
  if (!link) return;
  let last = null;
  try {
    last = JSON.parse(sessionStorage.getItem("nx:last-collection") || "null");
  } catch (e) {
    return;
  }
  if (!last || !last.url) return;
  link.href = last.url;
  const label = link.querySelector("[data-nx-keep-label]");
  if (label && last.title) label.textContent = "Back to " + last.title;
})();
